import styles from './header.module.scss'
import PropTypes from 'prop-types'
import { Container } from 'layout/container'
import { useState } from 'react'
import { SitePhone } from 'common/sitePhone'
import { useSitePhone } from 'hooks/useSitePhone'

const Header = ({ redirect = false, className = '' }) => {
  const [open, setOpen] = useState(false)
  const [sitePhone, sitePhoneLink] = useSitePhone()

  return (
    <div className={styles.header__wrapper + className}>
      <Container>
        <div className={styles.header}>
          <div className={styles.header__logo}>
            <a href="/">
              <img src="/static/img/logo.svg" alt={`Discount Fares`} />
            </a>
          </div>
          <div className={styles.header__separator} />
          <div className={styles.header__content}>
            <div className={styles.header__phone}>
              <span className={styles.header__phone__text}>Call 24/7:</span> <SitePhone />
            </div>
            <div className={`${styles.header__nav} ${open ? styles.header__nav_open : ''}`}>
              <button className={styles.header__navButton} onClick={() => setOpen(!open)}>
                <span />
                <span />
                <span />
              </button>
              <div className={styles.header__navContainer}>
                <nav className={`${styles.header__navList}`}>
                  <a onClick={() => setOpen(false)} href={`${redirect ? '/' : ''}#about-us`}>
                    About Us
                  </a>
                  <a onClick={() => setOpen(false)} href={`${redirect ? '/' : ''}#contacts`}>
                    Contacts
                  </a>
                </nav>
                <a className={styles.header__navCall} href={sitePhoneLink}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22.921" height="22.887">
                    <g data-name="Group 87" fill="none" stroke="#fff">
                      <path
                        data-name="Path 73"
                        d="M6.969 15.921c5.036 5.036 9.845 6.1 11.621 6.2a13 13 0 001.937-4.261 16.126 16.126 0 00-4.648-3.1l-1.937 1.937a11.592 11.592 0 01-4.648-3.1 11.58 11.58 0 01-3.1-4.649l1.937-1.937a16.13 16.13 0 00-3.1-4.648A12.988 12.988 0 00.77 4.3c.098 1.771 1.164 6.581 6.199 11.621z"
                      />
                      <path data-name="Path 74" d="M12.31 6.228a4.383 4.383 0 014.383 4.383" />
                      <path data-name="Path 75" d="M12.31 3.489a7.122 7.122 0 017.122 7.122" />
                      <path data-name="Path 76" d="M12.31.75a9.861 9.861 0 019.861 9.861" />
                    </g>
                  </svg>
                  <span>
                    Call 24/7: <strong>{sitePhone}</strong>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

Header.propTypes = {
  redirect: PropTypes.bool,
}

export { Header }
